import React, { useCallback } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withTranslation } from "react-i18next";
import { SupportModal, APP_FEEDBACK_TYPES } from "@tailormed/common-client/component/SupportModal";

import { selectShowSupport, selectUserId } from "../store/selector";
import ACTIONS from "../store/action";
import { sendSupportTicketAPI } from "../api/api";
import ErrorMessage from "./customComponent/customMessages/ErrorMessage";
import SuccessMessage from "./customComponent/customMessages/SuccessMessage";
import { ReactComponent as WarningIcon } from "../assets/svg/warning-icon-popup.svg";
import { useStandardizedTracking, FeatureGroups } from "../utils/pendo/useStandardizedTracking";
import { getPatientIdFromUrl } from "../utils/paytient";

const ContactSupportComponent = ({ t, showSupport, setShowSupport, closeModal }) => {
  const { track: trackStandardized } = useStandardizedTracking();

  const onTrack = useCallback(
    (eventName, additionalInfo = {}) =>
      trackStandardized(eventName, { featureGroup: FeatureGroups.CONTACT_SUPPORT, additionalInfo }),
    [trackStandardized]
  );

  const commentPrefix =
    showSupport.assistanceProgram && showSupport.assistanceProgram.name
      ? `Program name: ${showSupport.assistanceProgram.name} - `
      : "";

  const title = showSupport.assistanceProgram ? t("support.title", { name: showSupport.assistanceProgram.name }) : null;

  const onClose = () => {
    setShowSupport(false);
    closeModal();
  };

  return (
    <SupportModal
      open={showSupport.visible}
      onClose={onClose}
      submitTicket={sendSupportTicketAPI}
      feedbackTypes={APP_FEEDBACK_TYPES.FINANCIAL_NAVIGATION}
      title={title}
      patientId={getPatientIdFromUrl()}
      commentPrefix={commentPrefix}
      entryPoint={showSupport.entryPoint}
      onTrack={onTrack}
      showSuccessMessage={SuccessMessage}
      showErrorMessage={ErrorMessage}
      confirmCloseIcon={<WarningIcon />}
    />
  );
};

const mapDispatchToProps = (dispatch) => ({
  closeModal: () => dispatch(ACTIONS.setShowAssistanceProgramModal(false)),
  setShowSupport: (visible) => dispatch(ACTIONS.setShowSupport(visible))
});

const mapStateToProps = createStructuredSelector({
  userId: selectUserId,
  showSupport: selectShowSupport
});

const ContactSupport = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactSupportComponent));

export { ContactSupport };
